<div class="d-flex">
    <button kendoButton
            (click)="onDelete()"
            icon="trash"
            class="align-self-end">
    </button>
    <div class="flex-grow-1"
         style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: auto; gap: 12px;">
        <kendo-label text="Cargo name"
                     [ngClass]="cargoFieldIsValid('cargoTypeId') ? 'text-grey' : 'text-red'">
            <kendo-combobox [data]="cargoTypes()"
                            [value]="cargo().cargoTypeId"
                            (valueChange)="onCargoTypeChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'"
                            [class.border-red]="!cargoFieldIsValid('cargoTypeId')">
            </kendo-combobox>
        </kendo-label>
        <kendo-label text="Unit"
                     [ngClass]="cargoFieldIsValid('unitId') ? 'text-grey' : 'text-red'">
            <kendo-combobox [data]="cargoUnitTypes()"
                            [value]="cargo().unitId"
                            (valueChange)="onCargoUnitChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'"
                            [class.border-red]="!cargoFieldIsValid('unitId')">
            </kendo-combobox>
        </kendo-label>
        <kendo-label text="Quantity"
                     [ngClass]="cargoFieldIsValid('quantity') ? 'text-grey' : 'text-red'">
            <kendo-numerictextbox [spinners]="false"
                                [value]="cargo().quantity"
                                (valueChange)="onCargoQuantityChange($event)"
                                [fillMode]="'outline'"
                                [placeholder]="'-'"
                                [class.border-red]="!cargoFieldIsValid('quantity')">
            </kendo-numerictextbox>
        </kendo-label>
        <kendo-label text="Cargo operation"
                     class="text-grey">
            <kendo-combobox [data]="cargoOperations()"
                            [value]="cargo().cargoOperationTypeId"
                            (valueChange)="onCargoOperationChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'">
            </kendo-combobox>
        </kendo-label>
    </div>

</div>